/**
 * Module dependencies.
 */

import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

/**
 * Export `CopyId` component.
 *
 * A compact identifier cell: shows a shortened id, reveals a copy button on
 * hover, and shows the full id in a tooltip. Clicking copies to the clipboard.
 */

export function CopyId({ value }: { value: string }): JSX.Element {
  const [copied, setCopied] = useState(false);

  const copy = (event: React.MouseEvent) => {
    event.stopPropagation();
    navigator.clipboard?.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  return (
    <span className={'group relative inline-flex items-center gap-1 font-mono text-xs text-muted-foreground'}>
      {value.slice(0, 8)}

      <button
        aria-label={'Copy id'}
        className={'opacity-0 transition-opacity hover:text-foreground focus:opacity-100 group-hover:opacity-100'}
        onClick={copy}
        type={'button'}
      >
        {copied ? <Check className={'h-3 w-3 text-[#1B752B]'} /> : <Copy className={'h-3 w-3'} />}
      </button>

      <span
        className={
          'pointer-events-none absolute left-0 top-full z-20 mt-1 hidden whitespace-nowrap rounded-md bg-foreground px-2 py-1 text-[11px] font-normal text-background shadow-md group-hover:block'
        }
      >
        {value}
      </span>
    </span>
  );
}
